export class  LineDataItemInfo{

	constructor()
	{
		this.name = null;
		this.poiType = null;
		this.stationNum = null;
		this.uuid = null;
	}


	static GetLineDataItemInfo(jsonObj)
		{	
			let lineItem=null;
			if(jsonObj==null)return lineItem;
			lineItem=new LineDataItemInfo();
			lineItem.name=jsonObj.name;
			lineItem.poiType=jsonObj.poiType;
			lineItem.stationNum=jsonObj.stationNum;
			lineItem.uuid=jsonObj.uuid;
			
			return lineItem;
		}

}//end LineDataItemInfo

